import React from "react";
import { Store } from "lucide-react";
import { useTranslation } from "react-i18next";
import { fileUrl } from "@/lib/api";

export function ProductGallery({ gallery, displaySrc, displayIsAI, size, mainIdx, name, onThumb }) {
  const { t } = useTranslation();
  return (
    <div className="md:sticky md:top-6 md:self-start">
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-[#F3F3F3] flex items-center justify-center">
        {displaySrc ? (
          <img src={fileUrl(displaySrc)} alt={name} className="h-full w-full object-contain" data-testid="detail-main-image" />
        ) : (
          <div className="h-full w-full flex items-center justify-center"><Store className="h-12 w-12 text-[#cfc8ba]" /></div>
        )}
        {displayIsAI && (
          <span data-testid="detail-ai-badge" className="absolute bottom-2 left-2 bg-black/75 text-white font-jost text-[10px] uppercase tracking-widest px-2 py-1">
            {size ? t("detail.aiBadgeSize", { size }) : t("detail.aiBadge")}
          </span>
        )}
      </div>
      {gallery.length > 1 && (
        <div className="flex gap-2 mt-2 overflow-x-auto" data-testid="detail-gallery">
          {gallery.map((g, i) => (
            <button key={g.url} onClick={() => onThumb(i)} data-testid={`detail-thumb-${i}`} className={`relative h-20 w-16 shrink-0 overflow-hidden border bg-[#F3F3F3] ${(!displayIsAI && i === mainIdx) ? "border-[#1A1A1A]" : "border-transparent opacity-70"}`}>
              <img src={fileUrl(g.url)} alt={name} className="h-full w-full object-contain" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
